//信件
let ListView = require("clover/panel/component/common/ListView.js");
let EmailItemCommon = require("./EmailItemCommon");
let EmailItemGift = require("./EmailItemGift");
let EmailItemEnergy = require("./EmailItemEnergy");
let EmailItemChallenge = require("./EmailItemChallenge");

let EmailPanel = xClass("EmailPanel", BasePanel, function () {
    return cc.CSLoader.createNode(`cocos/mail_mail_main.csb`);
})

let RES = ["packed/EmailPanel.pack"];

EmailPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    let frame_res = DressManager.getInstance().getNeedFrameRes();
    RES = RES.concat(frame_res)
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask);
}

EmailPanel.prototype.ctor = function () {
    let self = this;
    BasePanel.prototype.ctor.call(self);
    self.EmailMgr = EmailManager.getInstance();
    self.EmailMgr.isBusy = false;
    self.nodepool = {};

    self.fitScreen();
    self.initUI();
    self.popup();
}

EmailPanel.prototype.initUI = function () {
    let self = this;
    self.mail_empty = self.getChildByName("mail_empty");
    self.mail_btn_del = self.getChildByName("mail_btn_del");
    self.lib_btn_green_normal4 = self.getChildByName("lib_btn_green_normal4");
    let com_close_red = self.getChildByName("com_close_red");
    let com_bg_big1 = self.getChildByName("com_bg_big1");
    //关闭邮件上限提醒tip
    let closeTip = function () {
        if (self.touchNode) {
            com_bg_big1.removeFromParent(true);
            self.touchNode.removeFromParent(true);
            self.touchNode = null;
        }
    }
    //
    quickBuildUIButton(self.lib_btn_green_normal4, () => {
        if (self.EmailMgr.isBusy) return;
        self.EmailMgr.isBusy = true;

        self.EmailMgr.mailBatchAccept().then(function (evt) {
            self.EmailMgr.isBusy = false;
            closeTip();
            //
            self.EmailMgr.getInfo().then(() => {
                self.refreshUI();
            }).catch((err) => {
                self.refreshUI();
                console.error("mailBatchAccept - getInfo", err);
            })
            //全部过期没有奖励和数据
            if(!evt.rewards) return;

            let rewards = evt.rewards;
            ActivityGetRewardsPanel.show({
                type: 1,
                add_model: "mail",
                rewardList: rewards,
                tobagAni: true,
                title: "normal",
                closeCb: () => {
                }
            })
            //
            let reward = "";
            table.each(rewards, function (item) {
                if (item) {
                    reward += item.itemId + "_" + item.num + ";";
                }
            })
            //
            self.EmailMgr.dcSimple("page_click", {
                click_type: "all_claim",
                session: self.EmailMgr.dcSession,
                sub_id: self.getDcSubId(evt.mailExpireInfos),
                reward,
            });
        }).catch((evt) => {
            self.EmailMgr.isBusy = false;
            console.error("mailBatchAccept", evt);
        });
    });

    quickBuildUIButton(com_close_red, () => {
        if (self.EmailMgr.isBusy) return;
        self.EmailMgr.isBusy = true;
        self.onClose();

        self.EmailMgr.dcSimple("page_click", {
            click_type: "close",
            session: self.EmailMgr.dcSession,
        });
    });

    quickBuildUIButton(self.mail_btn_del, () => {
        if (self.EmailMgr.isBusy) return;
        self.EmailMgr.isBusy = true;
        self.EmailMgr.mailBatchDelete().then(function (evt) {
            self.EmailMgr.isBusy = false;
            self.refreshUI();
            //
            self.EmailMgr.dcSimple("page_click", {
                click_type: "all_delete",
                session: self.EmailMgr.dcSession,
                sub_id: self.getDcSubId(evt.mailIds),
            });
        }).catch((evt) => {
            self.EmailMgr.isBusy = false;
            console.error("mailBatchDelete", evt);
        });
    });

    //创建滑动列表
    let scrollView = ListView.create(self);
    scrollView.setBounceEnabled(false);
    scrollView.setAnchorPoint(0, 1);
    scrollView.setContentSize(548, 650);
    scrollView.setPosition(-274, 335);
    self.addChild(scrollView);
    self.listView = scrollView;
    //屏蔽banner点击穿透
    let darkLayer = cc.LayerColor.create(new cc.Color(155, 0, 0, 0));
    darkLayer.setContentSize(720, 300);
    darkLayer.setPosition(-display.width / 2, scrollView.y);
    UIButton.create(darkLayer);
    darkLayer.setSwallowTouches(true);
    self.addChild(darkLayer, 90);
    //
    darkLayer = cc.LayerColor.create(new cc.Color(155, 0, 0, 0));
    darkLayer.setContentSize(720, 300);
    darkLayer.setPosition(-display.width / 2, scrollView.y - scrollView.height - darkLayer.height);
    UIButton.create(darkLayer);
    darkLayer.setSwallowTouches(true);
    self.addChild(darkLayer, 90);
    //邮件上限提醒
    if (self.EmailMgr.mails.length >= 90) {
        com_bg_big1.x = 0;
        com_bg_big1.setLocalZOrder(200);
        //
        let label = com_bg_big1.getChildByName("label");
        label.setString(getText("mail.max.tip"));
        label.y = com_bg_big1.height / 2;
        //
        let size = cc.size(cc.winSize.width, display.height);
        let colorLayer = cc.LayerColor.create(cc.c4b(0, 0, 0, 220), size.width, size.height);
        let touchNode = UIButton.create(colorLayer);
        self.addChild(touchNode, 199);
        touchNode.on(UIButtonEvent.Click, function () {
            if (self.EmailMgr.isBusy) return;
            closeTip();
        })
        touchNode.setPosition(cc.p(-size.width / 2, -size.height / 2));
        touchNode.setSwallowTouches(true);
        self.touchNode = touchNode;
        //动画
        self.EmailMgr.isBusy = true;
        colorLayer.setScale(0);
        com_bg_big1.setScale(0);
        self.lib_btn_green_normal4.setScale(0);
        //
        com_bg_big1.runAction(cc.Sequence.create(
            cc.DelayTime.create(0.5),
            cc.CallFunc.create(function () {
                colorLayer.setScale(1);
                com_bg_big1.setScale(1);
            }),
            cc.EaseSineOut.create(
                cc.ScaleTo.create(0.2, 1.16)
            ),
            cc.EaseSineIn.create(cc.ScaleTo.create(0.1, 1)),
            cc.CallFunc.create(function () {
                self.lib_btn_green_normal4.setScale(1);
                self.EmailMgr.isBusy = false;
            })
        ))
    } else {
        com_bg_big1.removeFromParent(true);
    }

    self.mail_btn_del.setLocalZOrder(99);
    self.lib_btn_green_normal4.setLocalZOrder(200);
    com_close_red.setLocalZOrder(99);
    //
    self.refreshUI();
    //
    self.nowMailCount = self.getCurMailList().length;
    self.listView.addEventListener(function (view, event) {
        if (event == ccui.ScrollView.EVENT_CONTAINER_MOVED) {
            if (self.listData.length < 5) return;//防止 数量不足以滑动时，会设置innerContainer坐标
            //滑动预留5px
            let posY = self.listView.getInnerContainerPosition().y;
            const containerHeight = self.listView.getInnerContainerSize().height;
            const limitY = self.nowMailCount * self.delegate_getItemHeight() - containerHeight;
            if (posY > limitY) {
                self.listView.stopAutoScroll();
                self.listView.setInnerContainerPosition(cc.p(0, limitY));
            }
        }
    })
    //
    let sub_id = "";
    for (let i = 0; i < self.EmailMgr.mails.length; i++) {
        let mail = self.EmailMgr.mails[i];
        if (mail) {
            sub_id += mail.mailId + "_";
        }
    }
    sub_id = sub_id.slice(0, -1);
    let params = self.EmailMgr.dcSimple("page_show", {
        sub_id,
    });
    self.EmailMgr.dcSession = params.session;
}

EmailPanel.prototype.refreshUI = function () {
    let self = this;
    //
    self.resetListView();
    //
    let mails = self.EmailMgr.mails;
    const hasMail = mails.length != 0;
    self.mail_empty.setVisible(!hasMail);
    self.listView.setVisible(hasMail);
    //
    let hasAcceptable = false;
    let hasDeletable = false;
    for (let i = 0; i < mails.length; i++) {
        let mail = mails[i];
        if (mail.deletableFlag == 1) {
            hasDeletable = true;
        } else if (mail.acceptableFlag == 1) {
            hasAcceptable = true;
        }
        if (hasAcceptable && hasDeletable) {
            break;
        }
    }
    self.mail_btn_del.setVisible(hasDeletable);
    self.lib_btn_green_normal4.setVisible(hasAcceptable);
    if (!hasMail) return;
    //
    let showList = function () {
        self.listData = self.EmailMgr.mails;
        self.listView.refresh(0);
        self.nowMailCount = self.getCurMailList().length;
        self.addChild(self.listView, 50);
    }
    const count = self.getCurMailList().length;
    if (count < mails.length && count < 10) {
        self.loadMailInfo(showList);
    } else {
        showList();
    }
}

//获取当前邮件列表（可展示的）
EmailPanel.prototype.getCurMailList = function () {
    let self = this;
    let list = self.EmailMgr.mails;
    let curList = [];
    for (let i = 0; i < list.length; i++) {
        let mail = list[i];
        if (mail && mail.mailType) {
            curList.push(mail);
        } else {
            //只取一直连续有数据的邮件，中间数据断开的不展示
            break;
        }
    }
    // console.error("getCurMailList", curList);
    return curList;
}

const LOAD_MAIL_INFO_INTERVAL = 20;//一次加载条数
//加载邮件信息
EmailPanel.prototype.loadMailInfo = function (cb) {
    let self = this;
    if (self.isLoading) {
        cb && cb();
        return;
    }

    //获取需要加载的邮件列表
    let getLoadList = function () {
        let list = self.EmailMgr.mails;
        let curList = [];
        for (let i = 0; i < list.length; i++) {
            let mail = list[i];
            if (mail && !mail.mailType) {
                curList.push(mail.mailId);
                //
                if (curList.length >= LOAD_MAIL_INFO_INTERVAL) {
                    break;
                }
            }
        }
        return curList;
    }

    let list = getLoadList()//.splice(0, LOAD_MAIL_INFO_INTERVAL);
    //
    if (list.length && !self.isClosed) {
        self.isLoading = true;
        self.EmailMgr.getInfo(list).then((evt) => {
            let showMails = evt.showMails || [];
            //
            let findMail = function (mails, mailId) {
                for (let i = 0; i < mails.length; i++) {
                    let mail = mails[i];
                    if (mail && mail.mailId == mailId) {
                        return true;
                    }
                }
                return false;
            }
            //
            let deleted = false;
            for (let i = 0; i < list.length; i++) {
                const mailId = list[i];
                if (!findMail(showMails, mailId)) {
                    self.EmailMgr.delMail(mailId);
                    deleted = true;
                }
            }
            if (deleted) {
                self.refreshUI();
            }
            //
            self.nowMailCount = self.getCurMailList().length;
            //
            if (list.length < LOAD_MAIL_INFO_INTERVAL) {//如果小于改条数，代表已全部拉取
                self.nowMailCount = 999;
            }
            self.isLoading = false;
            cb && cb();
        }).catch((err) => {
            self.isLoading = false;
            cb && cb();
            console.error("loadMailInfo", err);
        })
    } else {
        self.nowMailCount = 999;
    }

    return list;
}
//重置ListView。警惕列表节点缺失
EmailPanel.prototype.resetListView = function () {
    let self = this;
    self.listData = [];
    self.listView.stopAutoScroll();
    self.listView.removeFromParent(false);

    while (self.listView.getChildren().length) {
        let item = self.listView.children[0];
        item.removeFromParent(false);
        self.putItem(item);
    }
    self.listView.setInnerContainerSize(self.listView.getContentSize());
    self.listView.lastScrollY = 0;
    self.listView.setInnerContainerPosition(cc.p(0, 0));
}

EmailPanel.prototype.getDcSubId = function (mails) {
    let sub_id = "";
    for (let i = 0; i < mails.length; i++) {
        let mail = mails[i];
        if (mail) {
            sub_id += (mail.mailId || mail) + "_";
        }
    }
    sub_id = sub_id.slice(0, -1);
    return sub_id;
}

EmailPanel.prototype.delegate_getLength = function () {
    let self = this;
    return self.listData ? self.listData.length : 0;
}

EmailPanel.prototype.delegate_getItemHeight = function (index) {
    return 135;
}

EmailPanel.prototype.delegate_renderItem = function (index, itemView) {
    let self = this;
    let itemData = self.listData && self.listData[index];
    const type = itemData ? itemData.mailType : 0;
    //
    if (!itemView) {
        itemView = self.getItem(type);
    } else if (itemView.type != type) {
        itemView.removeFromParent(false);
        self.putItem(itemView);
        itemView = self.getItem(type);
    }

    if (itemData) {
        itemView.type = type;
        itemView.initData(itemData);
    }
    if (index > self.nowMailCount - 5) {
        self.loadMailInfo();
    }
    itemView.setVisible(true);
    return itemView;
}

EmailPanel.prototype.getItem = function (type) {
    let self = this;
    let item = null;
    let pool = self.nodepool[type];
    if (pool && pool.length) {
        item = pool.splice(0, 1)[0];
    } else {
        //与EmailType保持一致
        let arr = [EmailItemCommon, EmailItemCommon, EmailItemGift, EmailItemChallenge, EmailItemEnergy, EmailItemGift];
        let EmailItem = arr[type];
        if (!EmailItem) {
            console.error("EmailPanel getItem ", type);
            EmailItem = EmailItemCommon;
        }
        item = EmailItem.create();
    }
    return item;
}

EmailPanel.prototype.putItem = function (item) {
    let self = this;
    const type = item.type;
    if (!self.nodepool[type]) {
        self.nodepool[type] = [item];
    } else {
        self.nodepool[type].push(item);
    }
}

EmailPanel.prototype.clearPool = function () {
    let self = this;
    for (let type in self.nodepool) {
        let pool = self.nodepool[type];
        if (pool && pool.length) {
            for (let i = 0; i < pool.length; i++) {
                pool[i].removeFromParent(true);
            }
        }
        pool = [];
    }
}

EmailPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this;
    self.clearPool();
    let homeScene = require("clover/scene/HomeScene").getInstance();
    if (homeScene.btnLayer) {
        homeScene.btnLayer.updateBoxPrompt()
    }
    BasePanel.prototype.onClose.call(self, callback, arg);
}

EmailPanel.prototype.onCleanup = function () {
    let self = this;
    //
    ResManager.release(RES);
}

EmailPanel.prototype.fitScreen = function () {
    let self = this;
    const scaleY = display.height / GamePlayConfig_Design_Height;
    const scaleX = display.width / GamePlayConfig_Design_Width;
    if (scaleY / scaleX > 1) {

    } else {
        let scale = Math.min(scaleX, scaleY);
        self._scale = scale;
        self.setScale(self._scale);
    }
}

module.exports = EmailPanel;